import React, { FC } from 'react';
import {
  FpComponentsLibraryHelmet,
  FpComponentsLibraryProvider,
  MainLayout,
} from '@flicent/fieldpulse-react-component-library-frontend';

import JobPageContentProps from './JobPageContent.props';


const JobPageContent: FC<JobPageContentProps> = ({ isLoading, companyJobName, error, theme, children }) => {
  return (
    <FpComponentsLibraryProvider isOffline={ false } fpTheme={ theme }>
      <FpComponentsLibraryHelmet>
        <title>{ isLoading ? 'Loading…' : `${ companyJobName || 'Job' } Report` }</title>
      </FpComponentsLibraryHelmet>
      <MainLayout>
        { error ? <h1>Error: { error }</h1> : children }
      </MainLayout>
    </FpComponentsLibraryProvider>
  );
};


export default JobPageContent;